<div mat-dialog-title>Händler ändern</div>
<div mat-dialog-content>
    <p>Händler für {{ data?.anzahlTiere }} Tier(e) ändern.</p>
    <div class="one-row">
        <mat-form-field style="width: 100%">
            <mat-label>Händler</mat-label>
            <mat-select [formControl]="haendlerCtrl" [compareWith]="haendlerComparator">
                <mat-option *ngFor="let h of haendlerList" [value]="h">{{ h?.name }}</mat-option>
            </mat-select>
            <mat-hint>Bitte Händler auswählen</mat-hint>
        </mat-form-field>
        <button mat-icon-button color="accent" (click)="openCreateHaendlerDialog()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Abbrechen</button>
    <button mat-flat-button color="primary" (click)="save()" [disabled]="!haendlerCtrl.valid">Speichern</button>
</div>

